export const searchProductInitialState = {
  filters: {
    name: "",
    producttype: "",
    producttypeNames: "",
    companyid: "",
    companyNames: "",
    categories: "",
    categoryNames: "",
    fromCost: "",
    toCost: "",
    rating: "",
  },
  currentPage: 1,
  totalPages: 1,
  products: [],
  isProductListLoading: false,
};

export const searchProductReducer = (state, action) => {
  switch (action.type) {
    case "SET_PRODUCT_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        currentPage: 1, // reset to page 1 when filters change
      };
    case "SET_PRODUCT_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_PRODUCT_DATA":
      return {
        ...state,
        products: action.payload,
        isProductListLoading: false,
      };
    case "SET_PRODUCT_TOTAL_PAGES":
      return { ...state, totalPages: action.payload };
    case "SET_PRODUCT_LOADING":
      return { ...state, isProductListLoading: action.payload };
    case "RESET_PRODUCT_FILTERS":
      return {
        ...searchProductInitialState,
      };
    default:
      return state;
  }
};
